<mars-top-navbar [isInLanding]="false" />

<div class="main">
  <div class="content-container">
    <div class="main-container">
      <div class="w-full h-full flex flex-col gap-2xl">
        <div class="content grow">
          <router-outlet></router-outlet>
        </div>

        @if (
          mainService.bottomSectionTemplate() &&
          !mainService.sidePanelConfig().show
        ) {
          <div class="bottom-actions rounded-lg">
            <div class="content">
              <ng-container
                [ngTemplateOutlet]="mainService.bottomSectionTemplate()" />
            </div>
          </div>
        }
      </div>

      @if (mainService.sidePanelConfig().show) {
        <aside class="p-4xl">
          @if (mainService.sidePanelConfig().hasCloseButton) {
            <div class="close flex justify-end">
              <button
                class="p-sm rounded-sm border border-neutral-200"
                type="button"
                (click)="
                  mainService.sidePanelConfig.set({
                    show: false,
                    template: null,
                  })
                ">
                <mars-close-icon-lg />
              </button>
            </div>
          }
          @if (mainService.sidePanelConfig().template) {
            <ng-container
              [ngTemplateOutlet]="mainService.sidePanelConfig().template" />
          }
        </aside>
      }
    </div>
  </div>
</div>

@if (mainService.offCanvasConfig().show) {
  <div class="offCanvas-wrapper">
    <div
      marsClickOutSide
      (clickOutside)="
        mainService.offCanvasConfig().notAllowedToClose
          ? null
          : mainService.offCanvasConfig.set({
              show: false,
              template: null,
            })
      "
      class="offCanvas-container bg-white rounded-lg p-4xl m-2xl">
      <div class="offCanvas-content h-full">
        <div class="flex items-center justify-between">
          <p class="text-neutral-900 text-large font-semibold">
            {{ mainService.offCanvasConfig().title }}
          </p>

          @if (mainService.offCanvasConfig().hasCloseButton) {
            <button
              [disabled]="mainService.offCanvasConfig().notAllowedToClose"
              class="p-sm rounded-sm border border-neutral-200"
              type="button"
              (click)="
                mainService.offCanvasConfig().notAllowedToClose
                  ? null
                  : mainService.offCanvasConfig.set({
                      show: false,
                      template: null,
                    })
              ">
              <mars-close-icon-lg />
            </button>
          }
        </div>
        @if (mainService.offCanvasConfig().showLoader) {
          <div class="offcanvas-loader flex justify-center items-center">
            <mars-loader />
          </div>
        } @else {
          <ng-container
            [ngTemplateOutlet]="mainService.offCanvasConfig().template"
            [ngTemplateOutletContext]="{
              $implicit: mainService.offCanvasConfig().data,
            }" />
        }
      </div>
    </div>
  </div>
  <div class="offCanvas-overlay bg-neutral-500"></div>
}
